/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Artifactpackfinaliseevidence3Inputs */

const en_artifactpackfinaliseevidence3 = /** @type {(inputs: Artifactpackfinaliseevidence3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Attach a document to ${i?.count} timeline event(s) →`)
};

const pt_artifactpackfinaliseevidence3 = /** @type {(inputs: Artifactpackfinaliseevidence3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Anexar um documento a ${i?.count} evento(s) da cronologia →`)
};

/**
* | output |
* | --- |
* | "Attach a document to {count} timeline event(s) →" |
*
* @param {Artifactpackfinaliseevidence3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpackfinaliseevidence3 = /** @type {((inputs: Artifactpackfinaliseevidence3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpackfinaliseevidence3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpackfinaliseevidence3(inputs)
	return pt_artifactpackfinaliseevidence3(inputs)
});
export { artifactpackfinaliseevidence3 as "artifactPackFinaliseEvidence" }